import { render, staticRenderFns } from "./WayuuCommunityBonus.vue?vue&type=template&id=4c4a4b3b"
import script from "./WayuuCommunityBonus.vue?vue&type=script&lang=js"
export * from "./WayuuCommunityBonus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports